<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="fatDoctoIDIForm" *ngIf="fatDoctoIDIForm">
      <div fxLayout="row wrap">
        <div fxFlex="100" class="pr-1"><br></div>
        <div fxFlex="25" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field>
            <input matInput name="numeroRegistro" type="text"
              [formControl]="fatDoctoIDIForm?.controls['numeroRegistro']!" placeholder="Número do registro">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['numeroRegistro']?.hasError('required') && fatDoctoIDIForm?.controls['numeroRegistro']?.touched"
            class="form-error-msg"> Número do registro é obrigatório </small>
        </div>

        <div fxFlex="25" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field appearance="fill">
            <mat-label>Data do registro</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="fatDoctoIDIForm.controls['dataRegistro']">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker startView="month"></mat-datepicker>
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['dataRegistro']?.hasError('required') && fatDoctoIDIForm?.controls['dataRegistro']?.touched"
            class="form-error-msg"> Data do registro é obrigatório </small>

        </div>

        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field  style="min-width:80%;">
            <input matInput name="localDesembaraco" type="text"
              [formControl]="fatDoctoIDIForm?.controls['localDesembaraco']!" placeholder="Local de desembaraço">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['localDesembaraco']?.hasError('required') && fatDoctoIDIForm?.controls['localDesembaraco']?.touched"
            class="form-error-msg"> Local de desembaraço é obrigatório </small>
        </div>

        <!-- Campo: Data de Desembaraco -->
        <div fxFlex="25" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field appearance="fill">
            <mat-label>Data do Desembaraço</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="fatDoctoIDIForm.controls['dataDesembaraco']">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker startView="month"></mat-datepicker>
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['dataDesembaraco']?.hasError('required') && fatDoctoIDIForm?.controls['dataDesembaraco']?.touched"
            class="form-error-msg"> Data de Desembaraco é obrigatória </small>
        </div>
  

        <div fxFlex="20" class="pr-1 ml-1">
          <mat-form-field>
            <mat-label>Estado desembaraço</mat-label>
            <mat-select [formControl]="fatDoctoIDIForm.controls['ufDesembaraco']">
              <mat-option *ngFor="let uf of estados" [value]="uf.uf">
                {{uf.uf}} - {{uf.estado}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm.controls['ufDesembaraco'].hasError('required') && fatDoctoIDIForm.controls['ufDesembaraco'].touched"
            class="form-error-msg"> Estado é obrigatório </small>
        </div>

      
        <!-- Campo: Transporte Internacional -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field>
            <mat-label>Transporte Internacional </mat-label>
            <mat-select [formControl]="fatDoctoIDIForm?.controls['transporteInternacional']!">
              <mat-option *ngFor="let item of this.enums?.nfviaTransporteInternacional" [value]="item.name">
                {{item?.descricao}}
              </mat-option> 
            </mat-select>
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['transporteInternacional']?.hasError('required') && fatDoctoIDIForm?.controls['transporteInternacional']?.touched"
            class="form-error-msg"> Transporte Internacional é obrigatório </small>
        </div>

        <!-- Campo: Valor AFRMM -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field>
            <input matInput name="valorAFRMM" type="number" [formControl]="fatDoctoIDIForm?.controls['valorAFRMM']!"
              placeholder="Valor AFRMM">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['valorAFRMM']?.hasError('required') && fatDoctoIDIForm?.controls['valorAFRMM']?.touched"
            class="form-error-msg"> Valor AFRMM é obrigatório </small>
        </div>

        <!-- Campo: Forma de Importação/Intermediação -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field style="min-width:350px;">
            <mat-label>Forma de Importação/Intermediação </mat-label>
            <mat-select [formControl]="fatDoctoIDIForm?.controls['formaImportacaoIntermediacao']!">
              <mat-option *ngFor="let item of this.enums?.nfformaImportacaoIntermediacao" [value]="item.name">
                {{item?.descricao}}
              </mat-option> 
            </mat-select>
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['formaImportacaoIntermediacao']?.hasError('required') && fatDoctoIDIForm?.controls['formaImportacaoIntermediacao']?.touched"
            class="form-error-msg"> Forma de Importação/Intermediação é obrigatória </small>
        </div>
        <!-- Campo: CNPJ -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field  style="min-width:50%;">
            <input matInput name="cnpj" type="text" [formControl]="fatDoctoIDIForm?.controls['cnpj']!"
              placeholder="CNPJ do Adquirente">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['cnpj']?.hasError('required') && fatDoctoIDIForm?.controls['cnpj']?.touched"
            class="form-error-msg"> CNPJ é obrigatório </small>
        </div>
        <!-- Campo: UF do Terceiro -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field >
            <input matInput name="ufTerceiro" type="text" [formControl]="fatDoctoIDIForm?.controls['ufTerceiro']!"
              placeholder="UF do CNPJ do Adiquirente">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['ufTerceiro']?.hasError('required') && fatDoctoIDIForm?.controls['ufTerceiro']?.touched"
            class="form-error-msg"> UF do Terceiro (UF do CNPJ do Adiquirente) é obrigatória </small>
        </div>
        <!-- Campo: Código do Exportador -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field >
            <input matInput name="codigoExportador" type="text"
              [formControl]="fatDoctoIDIForm?.controls['codigoExportador']!" placeholder="Código do Exportador">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['codigoExportador']?.hasError('required') && fatDoctoIDIForm?.controls['codigoExportador']?.touched"
            class="form-error-msg"> Código do Exportador é obrigatório </small>
        </div>
        <!-- Campo: Número -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field >
            <input matInput name="numero" type="number" [formControl]="fatDoctoIDIForm?.controls['numero']!"
              placeholder="Número">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['numero']?.hasError('required') && fatDoctoIDIForm?.controls['numero']?.touched"
            class="form-error-msg"> Número é obrigatório </small>
        </div>
        <!-- Campo: Sequencial -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field >
            <input matInput name="sequencial" type="number" [formControl]="fatDoctoIDIForm?.controls['sequencial']!"
              placeholder="Sequencial">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['sequencial']?.hasError('required') && fatDoctoIDIForm?.controls['sequencial']?.touched"
            class="form-error-msg"> Sequencial é obrigatório </small>
        </div>
        <!-- Campo: Código do Fabricante -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field >
            <input matInput name="codigoFabricante" type="text"
              [formControl]="fatDoctoIDIForm?.controls['codigoFabricante']!" placeholder="Código do Fabricante">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['codigoFabricante']?.hasError('required') && fatDoctoIDIForm?.controls['codigoFabricante']?.touched"
            class="form-error-msg"> Código do Fabricante é obrigatório </small>
        </div>
        <!-- Campo: Desconto -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field >
            <input matInput name="desconto" type="number" [formControl]="fatDoctoIDIForm?.controls['desconto']!"
              placeholder="Desconto">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['desconto']?.hasError('required') && fatDoctoIDIForm?.controls['desconto']?.touched"
            class="form-error-msg"> Desconto é obrigatório </small>
        </div>
        <!-- Campo: Número do Ato Concessorio Drawback -->
        <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="35"  class="pr-1 ml-1">
          <mat-form-field  style="min-width:60%;" >
            <input matInput name="numeroAtoConcessorioDrawback" type="number"
              [formControl]="fatDoctoIDIForm?.controls['numeroAtoConcessorioDrawback']!"
              placeholder="Número do Ato Concessorio Drawback">
          </mat-form-field>
          <small
            *ngIf="fatDoctoIDIForm?.controls['numeroAtoConcessorioDrawback']?.hasError('required') && fatDoctoIDIForm?.controls['numeroAtoConcessorioDrawback']?.touched"
            class="form-error-msg"> Número do Ato Concessorio Drawback é obrigatório </small>
        </div>
      </div>
    </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <button class="mb-8" mat-raised-button [matTooltip]="'Salvar'" color="primary"
      (click)="this.save();$event.preventDefault();">
      <mat-icon>save</mat-icon>{{"SAVE" |
      translate }}
    </button>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>